export class Deal {
  constructor({
    _id = null,
    firstName = "",
    lastName = "",
    email = "",
    leadSource = "User Create",
    description = "",
    currentStatus = {
      name: "",
      color: "",
      id: null,
    },
    mobile = "",
    alternateNumber = "",
    probability = "",
    productCategory = "",
    productInterested = {
      name: "",
      id: null,
      _id: "",
    },
    ofCompany = "",
    assignedTo = "",
    mannualForm = true,
    textMessageAboutActivity = "",
    verificationRecord = [],
    paymentDetails = {
      amount: 0,
      totalPaymentVerified: "",
      paymentReceived: "",
      invoiceNumber: "",
      sourceOfFund: "",
      paymentStatusRemark: "",
      paymentDescription: "",
      loanAmount: 0,
      loanStatus: "",
    },
    editable = true,
    dealVerifiedByAccountant = false,
    dealVerifedByAccountOnDate = "",
    dealSentForApprovalToAccountant = false,
    dealSentForApprovalToAccountantOnDate = "",
    referenceSource = "",
    referenceByFranchiseCode = "",
    referenceByFranchiseMobile = "",
    referenceByFranchiseEmail = "",
    referenceByFranchiseName = "",
    franchiseDetails = "",
    franchiseRM = "",
    lastActivityDate = "",
    createdTime = "",
    question1 = "",
    question2 = "",
    question3 = "",
    city = "",
    meetingStatus = "",
    occupation = "",
    language = "",
    callHistoryRemarks = [],
    utmMedium = "",
    utmSource = "",
    utmContent = "",
    utmTerm = "",
    utmCampaign = "",
    dataSources = "",
    ipAddress = "",
    adAccount = "",
    adCampaign = "",
    adSet = "",
    ads = "",
    leadForm = "",
    facebookPage = "",
    adAccountId = "",
    adCampaignId = "",
    adSetId = "",
    adId = "",
    leadFormId = "",
    facebookPageId = "",
    brand = "",
    leadIdSocial = "",
    businessLeadType = "",
    platform = "",
    campaignName = "",
    adsName = "",
  } = {}) {
    this._id = _id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.leadSource = leadSource;
    this.description = description;
    this.currentStatus = currentStatus;
    this.mobile = mobile;
    this.alternateNumber = alternateNumber;
    this.probability = probability;
    this.productCategory = productCategory;
    this.productInterested = productInterested;
    this.ofCompany = ofCompany;
    this.assignedTo = assignedTo;
    this.mannualForm = mannualForm;
    this.textMessageAboutActivity = textMessageAboutActivity;
    this.verificationRecord = verificationRecord;
    this.paymentDetails = paymentDetails;
    this.editable = editable;
    this.dealVerifiedByAccountant = dealVerifiedByAccountant;
    this.dealVerifedByAccountOnDate = dealVerifedByAccountOnDate;
    this.dealSentForApprovalToAccountant = dealSentForApprovalToAccountant;
    this.dealSentForApprovalToAccountantOnDate =
      dealSentForApprovalToAccountantOnDate;
    this.referenceSource = referenceSource;
    this.referenceByFranchiseCode = referenceByFranchiseCode;
    this.referenceByFranchiseMobile = referenceByFranchiseMobile;
    this.referenceByFranchiseEmail = referenceByFranchiseEmail;
    this.referenceByFranchiseName = referenceByFranchiseName;
    this.franchiseDetails = franchiseDetails;
    this.franchiseRM = franchiseRM;
    this.lastActivityDate = lastActivityDate;
    this.createdTime = createdTime;
    this.question1 = question1;
    this.question2 = question2;
    this.question3 = question3;
    this.city = city;
    this.meetingStatus = meetingStatus;
    this.occupation = occupation;
    this.language = language;
    this.utmMedium = utmMedium;
    this.utmSource = utmSource;
    this.utmContent = utmContent;
    this.utmTerm = utmTerm;
    this.utmCampaign = utmCampaign;
    this.dataSources = dataSources;
    this.ipAddress = ipAddress;
    this.adAccount = adAccount;
    this.adCampaign = adCampaign;
    this.campaignName = campaignName;
    this.adsName = adsName;
    this.adSet = adSet;
    this.ads = ads;
    this.leadForm = leadForm;
    this.facebookPage = facebookPage;
    this.adAccountId = adAccountId;
    this.adCampaignId = adCampaignId;
    this.adSetId = adSetId;
    this.adId = adId;
    this.leadFormId = leadFormId;
    this.facebookPageId = facebookPageId;
    this.brand = brand;
    this.leadIdSocial = leadIdSocial;
    this.businessLeadType = businessLeadType;
    this.platform = platform;
  }

  static fromApiResponse(data) {
    return new Deal({
      _id: data._id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      leadSource: data.leadSource,
      description: data.description,
      currentStatus: data.currentStatus,
      mobile: data.mobile,
      alternateNumber: data.alternateNumber,
      probability: data.probability,
      productCategory: data.productCategory,
      productInterested: data.productInterested,
      ofCompany: data.ofCompany,
      assignedTo: data.assignedTo,
      mannualForm: data.mannualForm,
      textMessageAboutActivity: data.textMessageAboutActivity,
      verificationRecord: data.verificationRecord || [],
      paymentDetails: {
        amount: data.paymentDetails?.amount || "",
        totalPaymentVerified: data.paymentDetails?.totalPaymentVerified || "",
        paymentReceived: data.paymentDetails?.paymentReceived || "",
        invoiceNumber: data.paymentDetails?.invoiceNumber || "",
        sourceOfFund: data.paymentDetails?.sourceOfFund || "",
        paymentStatusRemark: data.paymentDetails?.paymentStatusRemark || "",
        paymentDescription: data.paymentDetails?.paymentDescription || "",
        loanAmount: data.paymentDetails?.loanAmount || 0,
        loanStatus: data.paymentDetails?.loanStatus || "",
      },
      editable: data.editable,
      dealVerifiedByAccountant: data.dealVerifiedByAccountant,
      dealVerifedByAccountOnDate: data.dealVerifedByAccountOnDate,
      dealSentForApprovalToAccountant: data.dealSentForApprovalToAccountant,
      dealSentForApprovalToAccountantOnDate:
        data.dealSentForApprovalToAccountantOnDate,
      referenceSource: data.referenceSource,
      referenceByFranchiseCode: data.referenceByFranchiseCode || "",
      referenceByFranchiseMobile: data.referenceByFranchiseMobile || "",
      referenceByFranchiseEmail: data.referenceByFranchiseEmail || "",
      referenceByFranchiseName: data.referenceByFranchiseName || "",
      franchiseDetails: data.franchiseDetails || "",
      franchiseRM: data.franchiseRM || "",
      lastActivityDate: data.lastActivityDate,
      createdTime: data.createdTime,
      question1: data.question1 || "",
      question2: data.question2 || "",
      question3: data.question3 || "",
      city: data.city || "",
      meetingStatus: data.meetingStatus || "",
      occupation: data.occupation || "",
      language: data.language || "",
      utmMedium: data.utmMedium,
      utmSource: data.utmSource,
      utmContent: data.utmContent,
      utmTerm: data.utmTerm,
      utmCampaign: data.utmCampaign,
      dataSources: data.dataSources,
      ipAddress: data.ipAddress,
      adAccount: data.adAccount,
      adCampaign: data.adCampaign,
      adSet: data.adSet,
      ads: data.ads,
      leadForm: data.leadForm,
      facebookPage: data.facebookPage,
      adAccountId: data.adAccountId,
      adCampaignId: data.adCampaignId,
      adSetId: data.adSetId,
      adId: data.adId,
      leadFormId: data.leadFormId,
      facebookPageId: data.facebookPageId,
      brand: data.brand,
      leadIdSocial: data.leadIdSocial,
      businessLeadType: data.businessLeadType,
      platform: data.platform,
      campaignName: data.campaignName,
      adsName: data.adsName,
    });
  }
}
